// extracted by mini-css-extract-plugin
export default {"list":"main-nav-links_list__Xg5DK","item":"main-nav-links_item__M90U1"};